import { slugifyCarSegment, compactUuidSlugSuffix, isCarUuidParam } from "@/lib/car-slug";

/** UUID в сегменте пути — тот же формат, что у машин. */
export const isVendorUuidParam = isCarUuidParam;

/** SEO-slug: название компании + суффикс из id (уникальность). */
export function buildVendorSlug(id: string, companyName: string): string {
  const name = slugifyCarSegment(companyName, 72);
  const suffix = compactUuidSlugSuffix(id);
  return `${name}-${suffix}`;
}

export type VendorLinkFields = {
  id: string;
  slug?: string | null;
  company_name: string;
};

export function vendorDetailPath(vendor: VendorLinkFields): string {
  const s = vendor.slug?.trim();
  if (s) return `/vendors/${s}`;
  return `/vendors/${buildVendorSlug(vendor.id, vendor.company_name)}`;
}
